import { forwardRef } from 'react';

import { cx } from '../../utils/cx';
import { Heading, type HeadingProps } from '../heading/heading';

import styles from './empty_state.module.css';

export type EmptyStateHeadingProps = HeadingProps;

/**
 * EmptyStateHeading - heading sub-component for empty states.
 */
export const EmptyStateHeading = forwardRef<
  HTMLHeadingElement,
  EmptyStateHeadingProps
>(({ className, level = 4, children, ...rest }, ref) => {
  return (
    <Heading
      ref={ref}
      level={level}
      className={cx([styles.heading, className])}
      {...rest}
    >
      {children}
    </Heading>
  );
});
